module.exports = __webpack_public_path__ + "static/img/2.e037959.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jxhh/2.png
// module id = f0Lr
// module chunks = 2